import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'shared/guards/login.guard';
import {ExportComponent} from './export.component';

const routes: Routes = [
  {path: 'export', component: ExportComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})

export class ExportRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/export/export-routing.module.ts